'use strict';

(() => {

  /* ======================================================================
   * Utilidades básicas
   * ====================================================================== */
  const D = document;
  const W = window;

  const $   = (selector, root = D) => root.querySelector(selector);
  const $$  = (selector, root = D) => Array.from(root.querySelectorAll(selector));
  const on  = (el, type, fn, opts) => el && el.addEventListener(type, fn, opts);
  const kids = (el, tag) => Array.from(el?.children || []).filter(n => n.tagName?.toLowerCase() === tag);

  const ready = (fn) => {
    if (D.readyState !== 'loading') fn();
    else on(D, 'DOMContentLoaded', fn);
  };

  const lockScroll = (shouldLock) => {
    const body = D.body;
    if (!body) return;
    body.toggleAttribute('data-no-scroll', shouldLock);
    body.style.overflow = shouldLock ? 'hidden' : '';
    if (!shouldLock) body.style.overflowY = '';
  };

  /* ======================================================================
   * 1) Menú de navegación (mobile / desktop)
   * ====================================================================== */
  function initNav() {
    const menuItems    = D.querySelectorAll('.setMenu');
    const nav          = D.querySelector('header > nav:first-of-type');
    const navListItems = D.querySelectorAll('header > nav:first-of-type > ul > li');
    const isMobile     = W.innerWidth <= 768;

    const removeAllOpen = () => navListItems.forEach(li => li.classList.remove('isOpen'));

    if (isMobile) {
      menuItems.forEach(item => {
        on(item, 'click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const isActive = item.parentElement.classList.toggle('isActive');
          if (isActive) {
            nav.style.maxHeight = 'none';
            nav.style.opacity   = '1';
            nav.style.overflow  = 'visible';
          } else {
            nav.style.maxHeight = '0';
            nav.style.opacity   = '0';
            nav.style.overflow  = 'hidden';
            removeAllOpen();
          }
        });
      });

      navListItems.forEach(item => {
        on(item, 'click', (e) => {
          if (e.target.tagName === 'A' && !e.target.closest('menu')) {
            e.preventDefault();
            e.stopPropagation();
            const isOpen = item.classList.contains('isOpen');
            removeAllOpen();
            if (!isOpen) {
              item.classList.add('isOpen');
              setTimeout(() => { nav.style.maxHeight = 'none'; }, 10);
            }
          }
        });
      });

      on(D, 'click', (e) => {
        if (!e.target.closest('header > nav:first-of-type')) removeAllOpen();
      });

    } else {
      navListItems.forEach(item => {
        on(item, 'mouseenter', () => { removeAllOpen(); item.classList.add('isOpen'); });
        on(item, 'mouseleave', () => item.classList.remove('isOpen'));
      });
    }
  }

  /* ======================================================================
   * 2) Header: ocultar al hacer scroll
   * ====================================================================== */
  function initHeaderHideOnScroll() {
    const header = $('header');
    if (!header) return;

    let lastY    = W.scrollY;
    let ticking  = false;

    const run = () => {
      ticking = false;
      if (!D.contains(header) || header.matches(':hover')) { lastY = W.scrollY; return; }

      const cur   = W.scrollY;
      const goOut = lastY >= 100 && cur > lastY;
      header.classList.toggle('isOUT', goOut);

      if (goOut) {
        const aside = $('aside');
        if (aside?.classList.contains('isOpen')) closeAside(aside);
      }

      lastY = cur;
    };

    on(W, 'scroll', () => {
      if (!ticking) { ticking = true; W.requestAnimationFrame(run); }
    }, { passive: true });
  }

  /* ======================================================================
   * 3) Aside
   * ====================================================================== */
  function initAsideToggles() {

    const showAllItems = (aside) => {
      kids(aside, 'item').forEach(el => {
        el.hidden        = false;
        el.style.display = 'block';
      });
    };

    const openAside = (asideId, accordionId) => {
      const aside = $('aside');
      if (!aside || !asideId) return;

      aside.classList.add('isOpen');
      lockScroll(true);

      const items = kids(aside, 'item').filter(el => el.hasAttribute('id'));

      if (items.length) {
        const exists = items.some(el => el.id === asideId);
        items.forEach(el => {
          const active     = !exists || el.id === asideId;
          el.hidden        = !active;
          el.style.display = active ? 'block' : 'none';
        });
      }

      if (accordionId) {
        setTimeout(() => {
          let dt = D.getElementById(accordionId);
          if (!dt) return;
          if (dt.tagName.toLowerCase() !== 'dt') {
            dt = dt.querySelector('dt') || dt.closest('dt') || dt;
          }

          const dl  = dt.closest('dl');
          const dts = dl ? kids(dl, 'dt') : [dt];
          const dds = dl ? kids(dl, 'dd') : [];

          dts.forEach(d => d.classList.remove('isActive'));
          dds.forEach(x => { x.style.transition = 'none'; x.style.maxHeight = null; });

          const dd = dt.nextElementSibling;
          if (dd && dd.tagName.toLowerCase() === 'dd') {
            dd.style.transition = 'none';
            dd.style.maxHeight  = dd.scrollHeight + 'px';
            requestAnimationFrame(() => { dd.style.transition = ''; });
          }
          dt.classList.add('isActive');
        }, 50);
      }

      console.log('[Aside] Abierto →', asideId, accordionId ? `| Acordeón: ${accordionId}` : '');
    };

    const closeAside = (aside) => {
      const el = aside || $('aside');
      if (!el) return;
      el.classList.remove('isOpen');
      lockScroll(false);
      showAllItems(el);
    };

    W.AR33         = W.AR33 || {};
    W.AR33.openAside  = openAside;
    W.AR33.closeAside = closeAside;

    on(D, 'click', (e) => {
      const aside = $('aside');
      if (!aside) return;

      const t = e.target;

      if (t === aside || t.closest('a[href="#Close"]')) {
        closeAside(aside);
        e.preventDefault();
        return;
      }

      const link = t.closest('a[href^="open#"]');
      if (!link) return;

      const raw      = link.getAttribute('href').replace(/^open/, '');
      const fragment = raw.startsWith('#') ? raw.slice(1) : raw;
      const ampIdx   = fragment.indexOf('&');
      const asideId  = ampIdx !== -1 ? fragment.slice(0, ampIdx) : fragment;
      const accId    = ampIdx !== -1 ? fragment.slice(ampIdx + 1) : null;

      if (!asideId) return;

      openAside(asideId, accId);
      e.preventDefault();
    });
  }

  /* ======================================================================
   * 4) Links externos
   * ====================================================================== */
  function enhanceExternalLinks() {
    for (const a of $$('a[href]')) {
      let url;
      try { url = new URL(a.getAttribute('href'), location.href); } catch { continue; }
      if ((url.protocol === 'http:' || url.protocol === 'https:') && url.origin !== location.origin) {
        a.target = '_blank';
        a.rel    = 'noopener noreferrer';
      }
    }
  }

  /* ======================================================================
   * 5) List/Grid toggle
   * ====================================================================== */
  function initListGridToggle() {
    const list = $('.isType');
    if (!list) return;

    const allGrids    = $$('grid');
    const nearestGrid = (from) => {
      let node = from;
      while (node) {
        const parent = node.parentElement;
        if (!parent) break;
        const grids = Array.from(parent.querySelectorAll('grid'));
        if (grids.length) {
          const siblings  = Array.from(parent.children);
          const iFrom     = siblings.indexOf(node);
          let best = null, bestDelta = Infinity;
          for (const g of grids) {
            let top = g;
            while (top && top.parentElement !== parent) top = top.parentElement;
            const d = Math.abs(siblings.indexOf(top || g) - iFrom);
            if (d < bestDelta) { bestDelta = d; best = g; }
          }
          if (best) return best;
        }
        node = parent;
      }
      return allGrids[0] || null;
    };

    const grid = nearestGrid(list);
    if (!grid) return;

    const key = 'gridMode:' + (grid.dataset.cacheKey || grid.id || ('idx:' + allGrids.indexOf(grid) + '@' + location.pathname));

    try {
      const saved = localStorage.getItem(key);
      if (saved === '0' || saved === '1') grid.classList.toggle('isAlt', saved === '1');
    } catch {}

    on(list, 'click', (e) => {
      const li = e.target.closest('li');
      if (!li || !list.contains(li)) return;
      list.querySelector('li.isActive')?.classList.remove('isActive');
      li.classList.add('isActive');
      const makeAlt = li.dataset.type === '1';
      grid.classList.toggle('isAlt', makeAlt);
      try { localStorage.setItem(key, makeAlt ? '1' : '0'); } catch {}
    });
  }

  /* ======================================================================
   * 6) Toggles de atributos
   * ====================================================================== */
  function initAttributeToggles() {
    const wrap = $('trigger');
    if (!wrap) return;

    const triggers  = $$('item', wrap);
    if (!triggers.length) return;

    const groups    = $$('toggles').map(w => $$('item', w));
    const hasGroups = groups.some(g => g.length);
    const N         = triggers.length;

    const parsePairs = (s) =>
      !s ? [] : s.split(';').map(x => x.trim()).filter(Boolean).map(p => {
        const i = p.indexOf('=');
        return i < 0 ? [p.trim(), ''] : [p.slice(0, i).trim(), p.slice(i + 1).trim()];
      }).filter(([k]) => k);

    const parseList = (s) => !s ? [] : s.split(',').map(x => x.trim()).filter(Boolean);

    const allNodes = () => [D.documentElement, D.body, ...(D.body ? D.body.querySelectorAll('*') : [])].filter(Boolean);

    const apply = (setPairs, rmList) => {
      const nodes = allNodes();
      if (rmList?.length)  for (const el of nodes) for (const name of rmList) try { el.removeAttribute(name); } catch {}
      if (setPairs?.length) for (const el of nodes) for (const [k, v] of setPairs) try {
        if (v === '' || v?.toLowerCase?.() === 'null') el.removeAttribute(k);
        else if (el.getAttribute(k) !== v) el.setAttribute(k, v);
      } catch {}
    };

    const setActive = (i) => {
      triggers.forEach(el => el.classList.remove('isActive'));
      triggers[i]?.classList.add('isActive');

      if (hasGroups) {
        for (const g of groups) {
          g.forEach((el, idx) => { el.style.display = (idx % N) === i ? 'block' : 'none'; });
        }
      }

      const t = triggers[i];
      if (!t) return;
      const setPairs = parsePairs(t.dataset.attrs);
      const rm       = parseList(t.dataset.remove);
      'requestIdleCallback' in W
        ? requestIdleCallback(() => apply(setPairs, rm), { timeout: 200 })
        : apply(setPairs, rm);
    };

    setActive(0);

    on(wrap, 'click', (e) => {
      const it  = e.target.closest('item');
      if (!it || !wrap.contains(it)) return;
      const idx = triggers.indexOf(it);
      if (idx >= 0) setActive(idx);
    });
  }

  /* ======================================================================
   * 7) Acordeón
   * ====================================================================== */
  function initAccordion() {
    for (const dl of $$('dl')) {
      const dts = kids(dl, 'dt');
      const dds = kids(dl, 'dd');

      dts.forEach(d => d.classList.remove('isActive'));
      dds.forEach(dd => (dd.style.maxHeight = null));

      on(dl, 'click', (e) => {
        const dt = e.target.closest('dt');
        if (!dt || !dl.contains(dt)) return;

        const dd        = dt.nextElementSibling;
        const wasActive = dt.classList.contains('isActive');

        dts.forEach(d => d.classList.remove('isActive'));
        dds.forEach(x => (x.style.maxHeight = null));

        if (!wasActive && dd && dd.tagName.toLowerCase() === 'dd') {
          dt.classList.add('isActive');
          dd.style.maxHeight = dd.scrollHeight + 'px';
        }
      });
    }
  }

  /* ======================================================================
   * 8) Galería
   * ====================================================================== */
  function initGallery() {
    const photos = $$('photo > item');
    const thumbs = $$('thumb > item');
    if (!photos.length || !thumbs.length) return;

    let active = -1;
    const setActive = (i) => {
      if (i === active) return;
      thumbs[active]?.classList?.remove('isActive');
      thumbs[i]?.classList?.add('isActive');
      active = i;
    };

    const thumbWrap = $('thumb');
    if (thumbWrap) {
      on(thumbWrap, 'click', (e) => {
        const t = e.target.closest('item');
        if (!t || !thumbWrap.contains(t)) return;
        const i = thumbs.indexOf(t);
        if (i < 0) return;
        setActive(i);
        photos[i]?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
      });
    }

    if ('IntersectionObserver' in W) {
      const index = new Map(photos.map((el, i) => [el, i]));
      const io    = new IntersectionObserver((entries) => {
        let best = -1, bestRatio = 0;
        for (const en of entries) {
          if (en.isIntersecting && en.intersectionRatio > bestRatio) {
            bestRatio = en.intersectionRatio;
            best      = index.get(en.target);
          }
        }
        if (best > -1) setActive(best);
      }, { threshold: 0.5 });
      photos.forEach(el => { if (el?.nodeType === 1) io.observe(el); });
    } else {
      setActive(0);
    }
  }

  /* ======================================================================
   * 9) Swipers
   * ====================================================================== */
  function initSwipers() {
    if (typeof W.Swiper !== 'function') return;

    D.querySelectorAll('.swiper').forEach((el) => {
      if (!el || el.nodeType !== 1) return;

      const ds  = el.dataset || {};
      const min = Number(ds.min) || 1;
      const max = Number(ds.max) || min;

      const prevEl     = el.querySelector('prev') || null;
      const nextEl     = el.querySelector('next') || null;
      const navigation = (prevEl || nextEl) ? { prevEl, nextEl } : undefined;

      const config = {
        centeredSlidesBounds: true,
        centeredSlides:       ds.half === 'true',
        slidesPerView:        min,
        observer:             true,
        loop:                 ds.loop === 'true',
        speed:                750,
        autoHeight:           true,
        autoplay:             ds.play === 'true' ? { delay: 4500, disableOnInteraction: false } : false,
        breakpoints: { 640: { slidesPerView: min }, 1024: { slidesPerView: max } }
      };
      if (navigation) config.navigation = navigation;

      try { new Swiper(el, config); }
      catch (err) { console.warn('⚠️ Swiper error:', err?.message || err); }
    });
  }

  /* ======================================================================
   * 10) Grid AJAX (Ver más)
   * ====================================================================== */
  function initAjaxGrid() {
    const grid = D.querySelector('grid[data-items]');
    const btn  = D.querySelector('a[data-ajax]');
    if (!grid || !btn) return;

    const BATCH = parseInt(grid.dataset.items, 10) || 8;

    let localItems = kids(grid, 'items')[0];
    if (!localItems) { localItems = D.createElement('items'); grid.appendChild(localItems); }

    btn.dataset.page = btn.dataset.page || '1';
    btn.dataset.busy = '0';

    const setBusy = (busy) => {
      btn.textContent = busy ? 'cargando' : 'Ver más';
      btn.dataset.busy = busy ? '1' : '0';
      btn.setAttribute('aria-disabled', busy ? 'true' : 'false');
      btn.style.pointerEvents = busy ? 'none' : '';
    };

    const nextURL = () => {
      const base     = new URL(btn.href, location.origin);
      const nextPage = (parseInt(btn.dataset.page, 10) || 1) + 1;
      base.searchParams.set('page', String(nextPage));
      return { url: base.toString(), nextPage };
    };

    const extractItems = (doc) => {
      let remote = doc.querySelector('grid > items');
      if (!remote) {
        const rg = doc.querySelector('grid[data-items], grid, [data-products], .grid, .product-grid');
        remote = (rg ? kids(rg, 'items')[0] : null) || rg;
      }
      if (!remote) return [];
      return Array.from(remote.children).filter(n => n.nodeType === 1).slice(0, BATCH);
    };

    on(btn, 'click', async (ev) => {
      ev.preventDefault();
      if (btn.dataset.busy === '1') return;
      setBusy(true);
      try {
        const { url, nextPage } = nextURL();
        const res   = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const items = extractItems(new DOMParser().parseFromString(await res.text(), 'text/html'));
        if (!items.length) { btn.remove(); return; }
        const frag = D.createDocumentFragment();
        items.forEach(el => frag.appendChild(el));
        localItems.appendChild(frag);
        btn.dataset.page = String(nextPage);
        setBusy(false);
      } catch (e) {
        console.error('❌ AJAX grid error:', e);
        btn.textContent = 'Error';
        setBusy(false);
      }
    });
  }

  /* ======================================================================
   * 11) Recomendaciones lazy
   * ====================================================================== */
  function initRecommendations() {
    const SEL     = '[data-loader]';
    const section = $(SEL);
    if (!section || section.dataset.loaded === 'true') return;

    const url = section.dataset.url;
    if (!url) return;

    const load = async () => {
      if (section.dataset.loaded === 'true') return;
      section.dataset.loaded = 'true';
      const ctrl      = new AbortController();
      const timeoutId = setTimeout(() => ctrl.abort(), 8000);
      try {
        const res      = await fetch(url, { headers: { Accept: 'text/html' }, signal: ctrl.signal });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const incoming = new DOMParser().parseFromString(await res.text(), 'text/html').querySelector(SEL);
        if (incoming?.innerHTML?.trim()) {
          requestAnimationFrame(() => {
            const frag = D.createDocumentFragment();
            Array.from(incoming.childNodes).forEach(n => frag.appendChild(n));
            section.replaceChildren(frag);
            delete section.dataset.url;
            initSwipers();
          });
        }
      } catch (err) {
        console.error('❌ Recommendations error:', err?.name === 'AbortError' ? 'timeout' : err);
        delete section.dataset.loaded;
      } finally {
        clearTimeout(timeoutId);
      }
    };

    if ('IntersectionObserver' in W) {
      const io = new IntersectionObserver((entries) => {
        for (const en of entries) {
          if (en.isIntersecting) { io.unobserve(en.target); load(); break; }
        }
      }, { root: null, threshold: 0.01, rootMargin: '400px 0px' });
      io.observe(section);
    } else {
      load();
    }
  }

  /* ======================================================================
   * 12) isCrop — Texto expandible
   * ====================================================================== */
  function initCrop() {
    $$('.isCrop').forEach(el => {
      const max   = parseInt(el.dataset.max, 10) || 200;
      const lMore = el.dataset.open  || 'Seguir Leyendo';
      const lLess = el.dataset.close || 'Cerrar';
      const full  = el.textContent.trim();
      if (full.length <= max) return;

      const original = el.innerHTML;
      const btn = Object.assign(D.createElement('a'), { className: 'isCrop-toggle', href: '#' });

      const collapse = () => {
        el.classList.remove('is-expanded');
        el.innerHTML = full.slice(0, max) + '\u2026 ';
        btn.textContent = lMore;
        el.appendChild(btn);
      };

      const expand = () => {
        el.classList.add('is-expanded');
        el.innerHTML = original + ' ';
        btn.textContent = lLess;
        el.appendChild(btn);
      };

      on(btn, 'click', (e) => { e.preventDefault(); el.classList.contains('is-expanded') ? collapse() : expand(); });
      collapse();
    });
  }

  /* ======================================================================
   * Init
   * ====================================================================== */
  ready(() => {
    initNav();
    initHeaderHideOnScroll();
    initAsideToggles();
    enhanceExternalLinks();
    initListGridToggle();
    initAttributeToggles();
    initAccordion();
    initGallery();
    initSwipers();
    initAjaxGrid();
    initRecommendations();
    initCrop();
  });

})();